export default __webpack_public_path__ + "static/media/video-content.bf30f55d.png";